// extracted by css-extract-rspack-plugin
export default {"squareBanner":"TransactionalMessageBanner-module__squareBanner__iYxL4"};